import { BanknotesIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions } from "../../shared/featureFactories";

export const AccountsFeature: FeatureMetadata = {
  id: "accounts",
  moduleName: "feesFinance",
  navigation: {
    label: "Accounts",
    path: "/accounts",
    icon: BanknotesIcon,
    order: 2,
  },
  route: {
    path: "/accounts",
    element: lazy(() => import("./addHeader/pages/AccountsPage")),
  },
  permissions: buildCrudPermissions("FeeFinance", "Accounts"),
  readiness: "live",
};
